"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SideDrawer_1 = __importDefault(require("./SideDrawer"));
exports.default = SideDrawer_1.default;
